import React from 'react';

function App() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: 'white'
    }}>
      <a href="https://image2brick.com" target="_blank" rel="noopener noreferrer">
        what's this?
      </a>
    </div>
  );
}

export default App;